export default {
  methods: {
    displayMjSelect(event) {
      if (!event) return
      return event.feature_tags && event.feature_tags.find(tag => tag.slug === 'mj_select')
    }
  }
}
